import { apiRequest } from '../../apiCall'
import { GetQueueCallReportByRecordNameRequest, GetQueueCallReportRequest } from '../../types/callQueueReport/apiRequestType'


export const getCallQueueReport = (params: GetQueueCallReportRequest) => apiRequest('CallQueueReport.Search', params, '', true)

export const getCallQueueReportByRecordName = (params: GetQueueCallReportByRecordNameRequest) => apiRequest('CallQueueReport.GetCallQueueReportByRecordName', {}, "?RecordName=" + params, true)


